import { Button, Container, Stack, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Footer from "splash_components/Splash/CommonComponents/Footer";
import { NavigationBar } from "splash_components/Splash/CommonComponents/NavigationBar";

import React from "react";

export default function GymSignupSuccess() {
  const TITLE = "We'll be in touch shortly!"
  const STAFF_SUBTITLE = "We will be in touch within the next 48 business hours. In the mean time, you can reach us at contact@cruxapp.ca."
  const NON_STAFF_SUBTITLE = "We'll reach out to the gym in the next few days."

  const theme = useTheme();

  // Check if the non_staff query param is set
  const urlParams = new URLSearchParams(window.location.search);
  const nonStaff = urlParams.get("non_staff");

  const subtitle = nonStaff ? NON_STAFF_SUBTITLE : STAFF_SUBTITLE;

  return (
    <div style={{ backgroundColor: "#F4F4F1", userSelect: "text" }}>
      {screen.width < theme.breakpoints.values.sm ? (
        // Mobile
        <Stack direction="column" sx={{ minHeight: "100vh" }}>
          <Box flex={1}>
            <NavigationBar theme={theme} mobile />
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
                paddingTop: theme.spacing(5),
              }}
            >

              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={2}
              >
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={4}
                  sx={{ width: "100%" }}
                >
                  <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "75px" }} />
                  <Typography variant="h4" sx={{ textAlign: "center" }}>
                    <b>{TITLE}</b>
                  </Typography>
                </Stack>
                <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                  {subtitle}
                </Typography>
              </Stack>
            </Container>

            <Box
              pb={theme.spacing(7)}
              pt={theme.spacing(1)}
            >
              <Container
                style={{
                  paddingLeft: theme.spacing(6),
                  paddingRight: theme.spacing(6),
                }}
              >
              </Container>
            </Box>
          </Box>
          <Footer theme={theme} />
        </Stack>
      ) : (
        // Desktop
        <Stack direction="column" sx={{ minHeight: "100vh" }}>
          <Stack flex={1}>
            <NavigationBar theme={theme} mobile={false} />
            <Stack pt={theme.spacing(12)} pb={theme.spacing(3)} sx={{ height: "100%", justifyContent: "center", alignItems: "center" }} flex={1} spacing={3}>
              <Stack direction="row" justifyContent="center" alignItems="center">
                <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "100px" }} />
              </Stack>
              <Typography variant="h3" sx={{ textAlign: "center", fontWeight: 900, maxWidth: "800px" }}>
                {TITLE}
              </Typography>
              <Typography
                variant="h6"
                style={{ maxWidth: "60vw" }}
                sx={{ textAlign: "center", marginTop: theme.spacing(1), maxWidth: "80%", fontWeight: 400 }}
              >
                {subtitle}
              </Typography>
            </Stack>
          </Stack>
          <Footer theme={theme} />
        </Stack>
      )
      }
    </div >
  );
}
